import { render, staticRenderFns } from "./SettingsFooter.vue?vue&type=template&id=7b56d75a&"
import script from "./SettingsFooter.vue?vue&type=script&lang=ts&"
export * from "./SettingsFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports